import {
  Box,
  BoxProps,
  Button,
  CircularProgress,
  Dialog,
  IconButton,
  Popper,
  Stack,
  styled,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import suzuShuffle from "./assets/licks//2024_11_suzu_shuffle.pdf";
import daKipLick from "./assets/licks/2018_07_Da_Kip_Lick.pdf";
import spineDayton from "./assets/licks/2019_09_Spine_Dayton_Lick.pdf";
import zoom202003 from "./assets/licks/2020_03_zoom.pdf";
import threeFour from "./assets/licks/2020_04_3_4.pdf";
import fourThree from "./assets/licks/2020_04_4_3.pdf";
import theBreak from "./assets/licks/2020_12_The_Break.pdf";
import crossmenLick from "./assets/licks/2021_01_Crossmen_Lick.pdf";
import julia2 from "./assets/licks/2021_02_julia2.pdf";
import sriRanch from "./assets/licks/2021_02_sriranch.pdf";
import untitled6 from "./assets/licks/2021_02_untitled6.pdf";
import untitled4 from "./assets/licks/2021_02_Untitled_4_Now.pdf";
import hearYe from "./assets/licks/2021_07_hear_ye.pdf";
import allAboard from "./assets/licks/2021_08_ALL_ABOARD.pdf";
import canes from "./assets/licks/2021_08_canes.pdf";
import julia3 from "./assets/licks/2021_08_julia_3.pdf";
import twantyWan from "./assets/licks/2021_08_TwantiWan.pdf";
import untitled5 from "./assets/licks/2021_08_Untitled_5.pdf";
import madVillainy from "./assets/licks/2023_01_MadVillainy.pdf";
import slam from "./assets/licks/2023_06_slam.pdf";
import marshmallow from "./assets/licks/2023_07_marshmallow.pdf";
import aerodynamic from "./assets/licks/203_02_Aerodynamic.pdf";
import catalina from "./assets/licks/2024_02_Catalina.pdf";
import suzuSamba from "./assets/licks/2025_06_suzu_samba.pdf";
import vinylLaundry from "./assets/licks/2025_09_vinyl_laundry.pdf";
import bloodAndMarrow from "./assets/licks/2025_10_blood_and_marrow.pdf";
import summerCut from "./assets/licks/2026_07_summer_cut.pdf";
import suzuSamba2 from "./assets/licks/2026_07_suszu_samba_ii.pdf";
import goldFinger from "./assets/licks/2026_03_gold_finger.pdf";
import { DetailsBasePage } from "./DetailsBasePage.tsx";
import { ChevronLeft, ChevronRight, OpenInNew } from "@mui/icons-material";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url,
).toString();

type LibraryEntry = {
  title: string;
  year: number;
  link: string;
  numPages?: number;
};

const allEntries: LibraryEntry[] = [
  { title: "Suzu's Samba II", year: 2026, link: suzuSamba2 },
  { title: "Summer Cut", year: 2026, link: summerCut },
  { title: "Gold Finger", year: 2026, link: goldFinger },
  { title: "Blood and Marrow", year: 2025, link: bloodAndMarrow, numPages: 2 },
  { title: "Vinyl Laundry", year: 2025, link: vinylLaundry },
  { title: "Suzu's Samba", year: 2025, link: suzuSamba },
  { title: "Aerodynamic", year: 2023, link: aerodynamic },
  { title: "Da Kip Lick", year: 2018, link: daKipLick },
  { title: "Spine Dayton Lick", year: 2019, link: spineDayton },
  { title: "Zoom", year: 2020, link: zoom202003 },
  { title: "三 (3:4)", year: 2020, link: threeFour },
  { title: "四 (4:3)", year: 2020, link: fourThree },
  { title: "The Break", year: 2020, link: theBreak },
  { title: "Crossmen Lick", year: 2021, link: crossmenLick },
  { title: "Untitled 4 Now", year: 2021, link: untitled4 },
  { title: "Hear Ye, Hear Ye! Red Light!", year: 2021, link: hearYe },
  { title: "ALL ABOARD", year: 2021, link: allAboard },
  { title: "...Canes?", year: 2021, link: canes },
  { title: "Julia #3", year: 2021, link: julia3 },
  { title: "Twanty Wan", year: 2021, link: twantyWan },
  { title: "Untitled 5 Now", year: 2021, link: untitled5 },
  { title: "Meat Grinder", year: 2023, link: madVillainy },
  { title: "Suzu's Shuffle", year: 2024, link: suzuShuffle },
  { title: "Catalina", year: 2024, link: catalina },
  { title: "Julia #2", year: 2021, link: julia2 },
  { title: "Buzz Light Beer (Untitled 6 Now)", year: 2021, link: untitled6 },
  { title: "SriRanch", year: 2021, link: sriRanch },
  { title: "Marshmallow", year: 2023, link: marshmallow },
  { title: "Slam", year: 2023, link: slam },
].sort((a, b) => b.year - a.year);

const COLLAPSED_SIZE = 8;

export const MusicDetails = () => {
  const [showAll, setShowAll] = useState(false);
  const [showMoreDisabled, setShowMoreDisabled] = useState(false);

  const [lastIndex, setLastIndex] = useState(COLLAPSED_SIZE);

  const handleClick = () => {
    setShowAll(!showAll);
    if (showAll) {
      setLastIndex(COLLAPSED_SIZE);
    } else {
      handleShowAll();
    }
  };
  const handleShowAll = () => {
    let count = 5;
    const invervalId = setInterval(() => {
      if (!allEntries || count >= allEntries.length) {
        clearInterval(invervalId);
      } else {
        setLastIndex((prev) => prev + 1);
        count++;
      }
    }, 250);
  };

  const [activeIdx, setActiveIdx] = useState<number | null>(null);

  return (
    <DetailsBasePage title="Music">
      <Typography component={"em"} variant="body2">
        The following is a collection rudimental earworms that I couldn't get
        out of my head. I've transcribed them for your learning pleasure (and so
        I can relearn them later).
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          justifyContent: "center",
          pt: 4,
        }}
      >
        {allEntries.slice(0, lastIndex).map((entry, idx) => (
          <LibraryEntryDetails
            onClick={() => setActiveIdx(idx)}
            onAnimationEnd={() => {
              if (idx === allEntries.length - 1) setShowMoreDisabled(false);
            }}
            sx={{
              ...(idx < COLLAPSED_SIZE && {
                animation: "none",
              }),
            }}
            entry={entry}
            key={entry.title}
            hoverable={activeIdx === null}
          />
        ))}
      </Box>

      <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <Button
          onClick={() => {
            handleClick();
            if (!showAll) setShowMoreDisabled(true);
          }}
          variant="outlined"
          disabled={showMoreDisabled}
        >
          {showAll ? "Show Less" : "Show All"}
        </Button>
      </Box>

      {activeIdx !== null && (
        <PdfDialog
          entry={allEntries[activeIdx]}
          onBackdropClick={() => setActiveIdx(null)}
          onPrevClick={
            activeIdx === null || activeIdx === 0
              ? undefined
              : () => setActiveIdx(activeIdx - 1)
          }
          onNextClick={
            activeIdx === null || activeIdx === allEntries.length - 1
              ? undefined
              : () => setActiveIdx(activeIdx + 1)
          }
        />
      )}
    </DetailsBasePage>
  );
};

export const PdfDialog = (props: {
  entry: LibraryEntry;
  onBackdropClick: () => void;
  onPrevClick?: () => void;
  onNextClick?: () => void;
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { link, numPages = 1 } = props.entry;

  const [loading, setLoading] = useState(true);
  const [backdropClickable, setBackdropClickable] = useState(false);

  useEffect(() => {
    handleLoadStart();
  }, [link]);

  const handleLoadStart = () => {
    setLoading(true);
    setBackdropClickable(false);
  };

  const handleLoadFinished = () => {
    setLoading(false);
    setTimeout(() => setBackdropClickable(true), 500);
  };

  const prevdisabled = !props.onPrevClick;
  const nextdisabled = !props.onNextClick;

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "ArrowLeft" && props.onPrevClick) {
        props.onPrevClick();
      } else if (event.key === "ArrowRight" && props.onNextClick) {
        props.onNextClick();
      } else if (event.key === "Escape") {
        props.onBackdropClick();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  });

  return (
    <Dialog
      open={true}
      onClose={backdropClickable ? props.onBackdropClick : undefined}
    >
      <IconButton
        onClick={() => window.open(link, "_blank")}
        sx={{
          zIndex: 9999999,
          position: "absolute",
          top: 8,
          right: 8,
          color: "primary.main",
          opacity: 0.5,
          transition: "opacity 0.3s",
          "&:hover": {
            opacity: 1,
          },
          ...(loading && { display: "none" }),
        }}
        size="small"
      >
        <OpenInNew />
      </IconButton>
      <Document
        file={link}
        loading={null}
        onLoadStart={handleLoadStart}
        onLoadSuccess={handleLoadFinished}
        onLoadError={handleLoadFinished}
      >
        {[...Array(numPages)].map((_, idx) => (
          <Page
            loading={null}
            key={idx}
            scale={isSmallScreen ? 0.5 : 0.9}
            pageNumber={idx + 1}
            renderAnnotationLayer={false}
            renderTextLayer={false}
          />
        ))}
      </Document>

      <Stack
        sx={{
          overflow: "hidden",
          position: "absolute",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          justifyContent: "space-between",
          alignItems: "center",
          flexDirection: "row",
          ...(loading && { display: "none" }),
        }}
        spacing={2}
        useFlexGap
      >
        <Box
          component={Button}
          onClick={props.onPrevClick}
          disabled={prevdisabled}
          sx={(theme) => ({
            backgroundColor: "transparent",
            display: "flex",
            padding: 4,
            alignItems: "center",
            height: "100%",
            transition: "background-color 0.8s",
            border: "none",
            borderRadius: 0,
            borderTopRightRadius: 8,
            borderBottomRightRadius: 8,
            "& svg": {
              opacity: 0.1,
              transition: "opacity 0.8s",
            },
            ...(!prevdisabled && {
              "&:hover": {
                backgroundColor: `${theme.palette.primary.main}33`,
                "& svg": {
                  opacity: 1,
                },
              },
            }),
          })}
        >
          <ChevronLeft />
        </Box>
        <Box
          component={Button}
          disabled={!props.onNextClick}
          onClick={props.onNextClick}
          sx={(theme) => ({
            backgroundColor: "transparent",
            padding: 4,
            border: "none",
            display: "flex",
            alignItems: "center",
            height: "100%",
            transition: "background-color 0.8s",
            borderRadius: 0,
            borderTopLeftRadius: 8,
            borderBottomLeftRadius: 8,
            "& svg": {
              opacity: 0.1,
              transition: "opacity 0.8s",
            },
            ...(!nextdisabled && {
              "&:hover": {
                backgroundColor: `${theme.palette.primary.main}33`,
                "& svg": {
                  opacity: 1,
                },
              },
            }),
          })}
        >
          <ChevronRight />
        </Box>
      </Stack>
    </Dialog>
  );
};

const LibraryEntryDetails = styled(
  (props: {
    entry: LibraryEntry;
    hoverable: boolean;
    className?: string;
    onAnimationEnd: BoxProps["onAnimationEnd"];
    onClick: BoxProps["onClick"];
  }) => {
    const {
      entry: { title, year, link },
      hoverable,
    } = props;

    //follow mouse position on hover
    const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
    const [hovered, setHovered] = useState(false);
    const [documentLoading, setDocumentLoading] = useState(true);
    const [finishedAnimating, setFinishedAnimating] = useState(false);

    //get window height
    const [windowHeight, setWindowHeight] = useState(window.innerHeight);
    useEffect(() => {
      const handleResize = () => {
        setWindowHeight(window.innerHeight);
      };
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);

    useEffect(() => {
      setTimeout(() => setFinishedAnimating(true), 1000);
    }, []);

    useEffect(() => {
      if (!hovered) {
        return;
      }

      const handleMouseMove = (event: MouseEvent) => {
        setMousePosition({ x: event.clientX, y: event.clientY });
      };

      window.addEventListener("mousemove", handleMouseMove);

      // Clean up the event listener on component unmount
      return () => {
        window.removeEventListener("mousemove", handleMouseMove);
      };
    }, [hovered]);

    const mouseRef = useRef<HTMLDivElement>(null);

    return (
      <Button
        component="div"
        variant="outlined"
        disableRipple={true}
        onClick={props.onClick}
        onAnimationEnd={props.onAnimationEnd}
        className={props.className}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        sx={(theme) => ({
          ...(finishedAnimating && {
            animation: "none !important",
            margin: "8px 8px !important",
            padding: "12px 8px !important",

            transition: "background-color 0.8s",
            "&:hover": {
              backgroundColor: `${theme.palette.primary.main}66`,
              cursor: "pointer",
            },
          }),
        })}
      >
        <Typography>
          <strong>{year}</strong> {title}
        </Typography>

        {hoverable && hovered && false && !!link && (
          <>
            <Box
              ref={mouseRef}
              sx={{
                position: "absolute",
                left: mousePosition.x,
                top: mousePosition.y, // Position the popover above the mouse cursor,
                width: 16,
                height: 16,
              }}
            ></Box>
            <Popper
              open={true}
              anchorEl={
                mouseRef.current ? (mouseRef.current as HTMLElement) : undefined
              }
              sx={(theme) => ({
                backgroundColor: "background.default",
                zIndex: 9999999,
                ...(!documentLoading && {
                  borderRadius: "8px",
                  overflow: "hidden",
                  border: `1px solid ${theme.palette.text.primary}`,
                }),
              })}
            >
              <Document
                file={link}
                onLoadStart={() => setDocumentLoading(true)}
                onLoadSuccess={() => setDocumentLoading(false)}
                loading={<CircularProgress size={"16px"} />}
              >
                <Page
                  pageNumber={1}
                  height={windowHeight / 2}
                  renderAnnotationLayer={false}
                  renderTextLayer={false}
                />
              </Document>
            </Popper>
          </>
        )}
      </Button>
    );
  },
)(({ theme }) => {
  return {
    position: "static",
    color: theme.palette.text.primary,
    textTransform: "none",
    padding: "12px 24px",
    margin: "8px -8px",
    border: "none",
    borderRadius: "4px",
    animation: "fadeOut 1s forwards ease-out",
    "@keyframes fadeOut": {
      from: { backgroundColor: `${theme.palette.primary.main}`, opacity: 0.3 },
      to: { backgroundColor: "transparent", opacity: 1 },
    },
  };
});
